// extracted by mini-css-extract-plugin
export var formContainer = "_lh-0";
export var message = "_lh-1";